import { useEffect, useState } from "react";
import { api } from "../utils/api";
import type { DesktopAgentStatusResponse } from "../types";

export function useDesktopAgentStatus() {
  const [status, setStatus] = useState<DesktopAgentStatusResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    api<DesktopAgentStatusResponse>("/api/desktop/me/status")
      .then((data) => {
        if (cancelled) return;
        setStatus(data);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err?.message || "Failed to load desktop status.");
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { status, loading, error };
}
